import { Button } from '~/shadcn/ui/button/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/shadcn/ui/dialog'
import { Spinner } from '~/shadcn/ui/spinner'

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isRequesting: boolean
}

function WithdrawFundsConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  isRequesting,
}: Props) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-background gap-10 p-6 py-12 md:p-12">
        <DialogHeader className="gap-10">
          <DialogTitle
            className="text-xl md:text-2xl text-left md:text-center"
            title="Ste si istý, že chcete urobiť výber?">
            Ste si istý, že chcete urobiť výber?
          </DialogTitle>
          <DialogDescription
            title="Pripísanie prostriedkov môže trvať 1 až 3 pracovné dni. Medzi tým vám môžu utiecť zaujímavé investičné príležitosti."
            className="text-base font-medium text-primary text-left md:text-center">
            Pripísanie prostriedkov môže trvať 1 až 3 pracovné dni. Medzi tým
            vám môžu utiecť zaujímavé investičné príležitosti.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col w-full items-center justify-center lg:flex-row gap-5 relative">
          <Button
            variant="accent"
            className="w-full lg:w-auto"
            onClick={onClose}>
            Späť
          </Button>
          <Button
            variant="outline"
            className="flex grow w-full lg:w-auto"
            disabled={isRequesting}
            onClick={onConfirm}>
            Áno, chcem potvrdiť výber{` `}
            {isRequesting && <Spinner className="size-4" />}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export { WithdrawFundsConfirmDialog }
